"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassCollectionsPaydownAllocationMethod = exports.ClassCurePaydownAllocationMethod = exports.ClassDrawRequestAllocationMethod = exports.FundingRequestComponentSettlementMethod = exports.FundingRequestGeneralPropertiesType = exports.FundingRequestComponentType = void 0;
var FundingRequestComponentType;
(function (FundingRequestComponentType) {
    FundingRequestComponentType["CollectionsPaydown"] = "collectionsPaydown";
    FundingRequestComponentType["CollectionsRecycle"] = "collectionsRecycle";
    FundingRequestComponentType["CurePaydown"] = "curePaydown";
    FundingRequestComponentType["DrawRequest"] = "drawRequest";
})(FundingRequestComponentType = exports.FundingRequestComponentType || (exports.FundingRequestComponentType = {}));
var FundingRequestGeneralPropertiesType;
(function (FundingRequestGeneralPropertiesType) {
    FundingRequestGeneralPropertiesType["Properties"] = "properties";
})(FundingRequestGeneralPropertiesType = exports.FundingRequestGeneralPropertiesType || (exports.FundingRequestGeneralPropertiesType = {}));
var FundingRequestComponentSettlementMethod;
(function (FundingRequestComponentSettlementMethod) {
    FundingRequestComponentSettlementMethod["TransactionScan"] = "transactionScan";
    FundingRequestComponentSettlementMethod["AutoSettle"] = "autoSettle";
    FundingRequestComponentSettlementMethod["Admin"] = "admin";
    FundingRequestComponentSettlementMethod["Api"] = "api";
})(FundingRequestComponentSettlementMethod = exports.FundingRequestComponentSettlementMethod || (exports.FundingRequestComponentSettlementMethod = {}));
var ClassDrawRequestAllocationMethod;
(function (ClassDrawRequestAllocationMethod) {
    ClassDrawRequestAllocationMethod["FixedAttachmentRateLimitProportion"] = "fixedAttachmentRateLimitProportion";
    ClassDrawRequestAllocationMethod["Cascade"] = "cascade";
})(ClassDrawRequestAllocationMethod = exports.ClassDrawRequestAllocationMethod || (exports.ClassDrawRequestAllocationMethod = {}));
var ClassCurePaydownAllocationMethod;
(function (ClassCurePaydownAllocationMethod) {
    ClassCurePaydownAllocationMethod["FixedAttachmentRateLimitProportion"] = "fixedAttachmentRateLimitProportion";
    ClassCurePaydownAllocationMethod["Cascade"] = "cascade";
})(ClassCurePaydownAllocationMethod = exports.ClassCurePaydownAllocationMethod || (exports.ClassCurePaydownAllocationMethod = {}));
var ClassCollectionsPaydownAllocationMethod;
(function (ClassCollectionsPaydownAllocationMethod) {
    ClassCollectionsPaydownAllocationMethod["FixedAttachmentRateLimitProportion"] = "fixedAttachmentRateLimitProportion";
    ClassCollectionsPaydownAllocationMethod["Empty"] = "empty";
})(ClassCollectionsPaydownAllocationMethod = exports.ClassCollectionsPaydownAllocationMethod || (exports.ClassCollectionsPaydownAllocationMethod = {}));
//# sourceMappingURL=FundingRequest.js.map